import { TranslateService } from "@ngx-translate/core";
import { Pipe, PipeTransform, inject } from "@angular/core";

import { Checkbox, Dropdown, Lookup, TranslationService } from "src/app/core";

@Pipe({
  name: "localizedName",
  standalone: true,
  pure: false,
})
export class LocalizedNamePipe implements PipeTransform {
  private translate = inject(TranslateService);
  private translationService = inject(TranslationService);

  transform(value: Lookup | Checkbox | Dropdown, ...args: unknown[]): unknown {
    const isEnglish = this.translationService.isEnglish;

    if (value.nameEn && value.nameAr) {
      const isLocalizationObject =
        this.translate.instant(value.nameEn) instanceof Object || this.translate.instant(value.nameAr) instanceof Object;

      return isEnglish
        ? isLocalizationObject
          ? value.nameEn
          : this.translate.instant(value.nameEn)
        : isLocalizationObject
          ? value.nameAr
          : this.translate.instant(value.nameAr);
    }

    return isEnglish ? value.nameEn || value.nameAr : value.nameAr || value.nameEn;
  }
}
